
import React from "react";
import {useEnhancedTranslation} from "laravel-inertia-backend";
import {Button, Container} from "react-bootstrap";

export default function Export(props) {
    const { t } = useEnhancedTranslation();

  const handleClick = () => {
    window.location.href ='export/download';
  }

  return (<Container fluid className={"pt-2"}>
          <div className="mt-1 pt-1 pb-3 d-flex">
              <h1>{t('Export')}</h1>
          </div>
      <Button onClick={handleClick}>Produkte als CSV Exportieren</Button>
  </Container>);
}



